import { makeStyles } from "@material-ui/core"

export default makeStyles(theme => ({
    root: {
        padding: 10,
        marginBottom: 10,
        boxShadow: "none"
    },
    avatarLarge: {
        width: 100,
        height: 100,
        marginBottom: theme.spacing(1)
    },
    heading: {
        fontWeight: "bold",
        fontSize: 14
    },
    bottomContent: {
        display: "flex",
        alignItems: "center"
    },
    flexRow: {
        display: "flex",
        flexDirection: "row"
    },
    flexColumn: {
        display: "flex",
        flexDirection: "column"
    },
    flexItem: {
        flex: "1 1 0px"
    },
    avatarImg: {
        width: "100%",
        height: "auto",
        objectFit: "initial"
    },
    capitalized: {
        textTransform: "uppercase"
    },
    accordionSummary: {
        margin: 0,
        height: 36,
        minHeight: 0,
        "& div": {
            margin: 0,
            minHeight: 0
        }
    },
    basis20: {
        flexBasis: "20%"
    },
    padding4: {
        padding: 4
    },
    textField: {
        width: "75px"
    },
    mobileTextField: {
        width: "75px",
        marginRight: "1rem"
    },
    loadingAnimation: {
        width: "100%",
        height: 100
    },
    mobileLoadingAnimation: {
        width: "100%",
        height: "350px"
    },
    flexEnd: {
        justifyContent: "flex-end"
    },
    mobileProductCardHeader: {
        display: "flex",
        flexDirection: "row",
        maxHeight: "50%",
        overflowY: "scroll",
        overflowX: "hidden",
        marginBottom: "1rem",
        gap: "1rem"
    },
    moreInfo: {
        padding: 0,
        marginBottom: 0
    },
    mobilePriceBox: {
        display: "flex",
        flexDirection: "row",
        maxHeight: "50%",
        overflowY: "scroll",
        marginBottom: "1rem"
    },
    marginBottom1: {
        marginBottom: "1rem"
    },
    marginNone: {
        margin: 0
    },
    marginRight24: {
        marginRight: "24px"
    }
}))
